<main class="check">
  <header [attr.id]="data.title">
    <h3 [class.error]="!data.isPassed">{{ data.title }}</h3>
  </header>

  <section
    class="check-cases"
    [class.border]="data.isApplicable"
    [attr.id]="data.title"
  >
    <div class="cases">
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.waterSupplyAccordingTable4"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.riskPerceptionMeetStandard"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.waterSupplyPipeDiameter"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.pumpDetails"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.pumpCommandBoard"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.pumpCannotStop"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.tapsLocked"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.tapsMarked"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.waterSupplyTapAndRollerInterval"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.a_4_4_2"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.a_5_3_2"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.a_5_6"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.a_5_7"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.a_5_8"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.a_6_1"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.a_6_2"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.a_8_1"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.a_8_2"
      ></authority-labs-check-case>
      <authority-labs-check-case
        (dataChange)="onDataChange()"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [inspection]="data.a_8_3"
      ></authority-labs-check-case>
    </div>
  </section>
</main>
